import { render } from "./BankAccountM.vue?vue&type=template&id=efd20c88&scoped=true"
import script from "./BankAccountM.vue?vue&type=script&lang=js"
export * from "./BankAccountM.vue?vue&type=script&lang=js"

import "./BankAccountM.vue?vue&type=style&index=0&id=efd20c88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd20c88"]])

export default __exports__